import { Alert, Box, useTheme } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
import { SearchResults } from "@/Search/SearchResults";
import { useDeviceDatasets } from "@/shared/domain/devices/hooks/useDeviceDatasets";

interface DeviceDatasetsProps {
  deviceId: string;
}

export function DeviceDatasets({ deviceId }: DeviceDatasetsProps) {
  const theme = useTheme();
  const { currentOrganization } = useAuth();
  const [selectedDatasets, setSelectedDatasets] = React.useState<Set<string>>(
    new Set(),
  );
  const [lastError, setLastError] = React.useState<Error | null>(null);

  const { data: queryId, error } = useDeviceDatasets(
    deviceId,
    currentOrganization?.org_id,
  );

  if (error) {
    return (
      <Box mt={theme.spacing(1)} mb={theme.spacing(2)}>
        <Alert severity="error">
          Failed to load datasets for device {deviceId}: {error.message}
        </Alert>
      </Box>
    );
  }

  return (
    <Box mt={theme.spacing(-1)} mb={theme.spacing(2)}>
      <SearchResults
        queryId={queryId}
        lastError={lastError}
        onError={setLastError}
        selectedDatasets={selectedDatasets}
        setSelectedDatasets={setSelectedDatasets}
      />
    </Box>
  );
}
